const prefix = type => `@NOTIFICATION/${type}`;

export const TRIGGER_NOTIFICATION = prefix("TRIGGER_NOTIFICATION");
